import {Observable} from 'rxjs';
import {CpmCS3BucketApiModel} from '../../models/c-global/cpmc-s3-bucket.api-model';
import {
    CpmCS3BucketCreateApiSchema,
    CpmCS3BucketUpdateApiSchema
} from '../../schemas/c-global/cpmc-s3-bucket.api-schemas';
import {CpmCApiBridge} from '../../../../../src/app/cpmc-api-bridge';
import {CpmCQueryPaginatorConfig, CpmCQueryPaginatorConfigUtils} from '../../cpmc-defines';
import {AllowedQueryParamTypes, QueryParams} from '../../../../../sdk/src/utils/query.utils';
import {CpmCPaginatedResultAPISchema} from '../../schemas/cpmc-paginated-result.api-schemas';

export type CpmCGetS3BucketListParams = {
    [K in keyof CpmCS3BucketApiModel]?: CpmCS3BucketApiModel[K] extends AllowedQueryParamTypes
        ? CpmCS3BucketApiModel[K]
        : never;
} & QueryParams;

/**
 * S3Bucket Api Service
 */
export class CpmCS3BucketApiService {
    public static readonly dPaginatorConfig: CpmCQueryPaginatorConfig = {limit: -1, sort: 'name', order: 1};

    // ===============================================================
    // ===============================================================

    public static baseUrl() {
        return CpmCApiBridge.getBackendBaseURL() + 'api/core/v1/s3-bucket';
    }

    // ===============================================================
    // ===============================================================

    public static endpointList(): string {
        return `${CpmCS3BucketApiService.baseUrl()}/list`;
    }
    public static endpointNew(): string {
        return `${CpmCS3BucketApiService.baseUrl()}`;
    }
    public static endpointGet(oo8ConnectorUUID: string): string {
        return `${CpmCS3BucketApiService.baseUrl()}/${oo8ConnectorUUID}`;
    }
    public static endpointEdit(oo8ConnectorUUID: string): string {
        return `${CpmCS3BucketApiService.baseUrl()}/${oo8ConnectorUUID}`;
    }
    public static endpointDelete(oo8ConnectorUUID: string): string {
        return `${CpmCS3BucketApiService.baseUrl()}/${oo8ConnectorUUID}`;
    }

    // ===============================================================
    // ===============================================================

    public static getS3BucketList(
        params: CpmCGetS3BucketListParams = {},
        paginatorConfig: CpmCQueryPaginatorConfig = CpmCS3BucketApiService.dPaginatorConfig
    ): Observable<CpmCPaginatedResultAPISchema<CpmCS3BucketApiModel>> {
        return CpmCApiBridge.httpGet<CpmCPaginatedResultAPISchema<CpmCS3BucketApiModel>>(
            CpmCS3BucketApiService.endpointList(),
            {
                ...(params as QueryParams),
                ...CpmCQueryPaginatorConfigUtils.toQueryParams(paginatorConfig)
            }
        );
    }
    public static getS3BucketByUUID(oo8ConnectorUUID: string): Observable<CpmCS3BucketApiModel> {
        return CpmCApiBridge.httpGet<CpmCS3BucketApiModel>(CpmCS3BucketApiService.endpointGet(oo8ConnectorUUID));
    }
    public static createS3Bucket(payload: CpmCS3BucketCreateApiSchema): Observable<CpmCS3BucketApiModel> {
        return CpmCApiBridge.httpPost<CpmCS3BucketApiModel>(CpmCS3BucketApiService.endpointNew(), payload);
    }
    public static updateS3Bucket(
        oo8ConnectorUUID: string,
        payload: CpmCS3BucketUpdateApiSchema
    ): Observable<CpmCS3BucketApiModel> {
        return CpmCApiBridge.httpPut<CpmCS3BucketApiModel>(
            CpmCS3BucketApiService.endpointEdit(oo8ConnectorUUID),
            payload
        );
    }
    public static deleteS3Bucket(oo8ConnectorUUID: string): Observable<boolean> {
        return CpmCApiBridge.httpDelete<boolean>(CpmCS3BucketApiService.endpointDelete(oo8ConnectorUUID));
    }
}
